'use client'
import PlayerWrapper from '@/components/video-page/player-wrapper'
type Props = {
  params: { id: string }
}
export default function EmbedVideoPage({ params }: Props) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        margin: '0 auto',
        background: 'black',
        overflow: 'hidden',
      }}
    >
      <PlayerWrapper
        pageUrl={params.id}
        isInactivityTimer={false}
        handleInactivityTimer={() => { }}
        embeded={true}
      />
    </div>
  )
}
